export const IMAGES = {
  heroCab: "https://images.unsplash.com/photo-1550431528-122aefbbd2a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  skyline: "https://images.unsplash.com/photo-1543832923-44667a44c804?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cabStreet: "https://images.unsplash.com/photo-1623189831691-601692d33879?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cabRain: "https://images.unsplash.com/photo-1665695503038-a5c3127f3da3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  airport: "https://images.unsplash.com/photo-1553619948-505cc1cdc320?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  airportTerminal: "https://images.unsplash.com/photo-1655919640606-28088c64edb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  station: "https://images.unsplash.com/photo-1684934899514-772e03714de5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  executiveDriver: "https://images.unsplash.com/photo-1616805111996-e39d9a19e35c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  countryside: "https://images.unsplash.com/photo-1568190538421-53523065d4b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mercedes: "https://images.unsplash.com/photo-1610099610040-ab19f3a5ec35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const VEHICLE_IMAGES = {
  saloon: "https://images.unsplash.com/photo-1550431528-122aefbbd2a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  estate: "https://images.unsplash.com/photo-1612014414973-a665d5688c62?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  executive: "https://images.unsplash.com/photo-1610099610040-ab19f3a5ec35?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  mpv: "https://images.unsplash.com/photo-1589148938909-4d241c91ee52?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};

export const NAV_LINKS = [
  { label: "Book a Taxi", to: "/search" },
  { label: "Airport", to: "/airport-transfers" },
  { label: "Stations", to: "/station-transfers" },
  { label: "Outstation", to: "/outstation" },
  { label: "Tourist", to: "/tourist" },
  { label: "Corporate", to: "/corporate" },
  { label: "Become a Driver", to: "/become-a-driver" },
  { label: "Help", to: "/help" },
];

export const STATUS_LABELS = {
  pending: "Pending",
  confirmed: "Confirmed",
  driver_assigned: "Driver Assigned",
  driver_accepted: "Driver Accepted",
  driver_enroute: "Driver En Route",
  driver_arrived: "Arrived",
  picked_up: "Passenger Picked Up",
  journey_started: "Journey Started",
  completed: "Completed",
  cancelled: "Cancelled",
  no_show: "No Show",
  failed: "Failed",
};

export const STATUS_COLORS = {
  pending: "bg-amber-100 text-amber-800",
  confirmed: "bg-blue-100 text-blue-800",
  driver_assigned: "bg-blue-100 text-blue-800",
  driver_accepted: "bg-indigo-100 text-indigo-800",
  driver_enroute: "bg-indigo-100 text-indigo-800",
  driver_arrived: "bg-purple-100 text-purple-800",
  picked_up: "bg-purple-100 text-purple-800",
  journey_started: "bg-cyan-100 text-cyan-800",
  completed: "bg-emerald-100 text-emerald-800",
  cancelled: "bg-red-100 text-red-800",
  no_show: "bg-red-100 text-red-800",
  failed: "bg-red-100 text-red-800",
};

export const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

export const saveSearch = (data) => sessionStorage.setItem("sf4u_search", JSON.stringify(data));
export const loadSearch = () => { try { return JSON.parse(sessionStorage.getItem("sf4u_search")); } catch { return null; } };
export const saveOffer = (data) => sessionStorage.setItem("sf4u_offer", JSON.stringify(data));
export const loadOffer = () => { try { return JSON.parse(sessionStorage.getItem("sf4u_offer")); } catch { return null; } };
